<div class="container-fluid row col-12 no-gutters">
  <div class="col-xl-9 col-md-9 col-sm-12 no-gutters">
    <form [formGroup]="sptForm" class="col-xl-9 col-md-9 col-sm-12 m-auto no-gutters">
      <h6 class="col-12 mb-3 text-normal"><strong>Application
          Description</strong></h6>
      <div class="col-12 text-normal mb-3">Collaboration solution to raise eRFQ/Bids Purchase Requests and Negotiation
        workflow. Application supports also PO
        confirmation and ship notice coming from Suppliers. Application available for REN Gird Solutions.
      </div>
      <h6 class="col-12 text-normal"><strong>Registration
          Question</strong></h6>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          Company Name
          <span style="color: red;">*
          </span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="companyName" name="companyName" matInput #companyName placeholder="" maxlength="50">
          <mat-hint align="end">{{companyName.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">Address
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="address" name="address" matInput #address placeholder="" maxlength="50">
          <mat-hint align="end">{{address.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">City
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="city" name="city" matInput #city placeholder="" maxlength="50">
          <mat-hint align="end">{{city.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          Country
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="country" name="country" matInput #country placeholder="" maxlength="50">
          <mat-hint align="end">{{country.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          Region
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <mat-select formControlName="region">
            <mat-option *ngFor="let item of regions" [value]="item">
              {{item}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          Email Address
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="email" name="email" matInput #email placeholder="" maxlength="50">
          <mat-hint align="end">{{email.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          Contact Name
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="contactName" name="contactName" matInput #contactName placeholder="" maxlength="50">
          <mat-hint align="end">{{contactName.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          Phone Number
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="phone" name="phone" matInput #phone placeholder="" maxlength="50">
          <mat-hint align="end">{{phone.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row col-12 mt-3 no-gutters">
        <div class="col-12 text-normal">
          Do you already have a GE SAP ID ?
        </div>
        <div class="col-12 text-normal">
          <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
            formControlName="SAPID" name="SAPID">
            <mat-radio-button class="example-radio-button" *ngFor="let option of optionList" [value]="option"
              (change)="checkValid($event)">
              {{option}}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="row col-12 mt-3 no-gutters" *ngIf="sptForm.value?.SAPID === 'Yes'">
        <div class="col-12 text-normal">
          If yes, please provide your GE SAP ID
          <span style="color: red;">*</span>
        </div>
        <mat-form-field floatLabel="never" appearance="outline" class="col-12 justify-content-center text-normal">
          <input formControlName="provideSAPID" name="provideSAPID" matInput #provideSAPID placeholder="" maxlength="50">
          <mat-hint align="end">{{provideSAPID.value.length}} / 50</mat-hint>
        </mat-form-field>
      </div>
      <div class="row no-gutters col-12 d-flex align-items-center justify-content-center pt-4">
        <button class="btn btn-primary btn-vernova button col-xl-5 col-md-6 col-sm-12 col-12 text-normal"
        style="font-size: 18px;" (click)="submitSptFormForm()">
          <span>
            Request Access
          </span>
        </button>
      </div>
      <br>
    </form>
  </div>
  <div class="col-12 col-sm-12 col-md-3 col-xl-3 no-gutters">
    <div class="row no-gutters col-12 align-items-center justify-content-center d-none d-sm-block">
      <button class="btn btn-primary btn-vernova button col-12" style="font-size: 18px;" (click)="goToApplication()">
        <span>
          Go To Application
          <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
        </span>
      </button>
    </div>
    <hr>
    <div class="col-12">
      <h6>
        <strong class="mt-3 text-lable">
          Support
        </strong>
      </h6>
      <div class="col-12 mt-3 p-0 text-normal d-block d-sm-none">
        <button class="btn btn-primary btn-vernova button col-12" style="font-size: 18px;" (click)="goToApplication()">
          <span>
            Go To Application
            <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
          </span>
        </button>
        <hr>
      </div>
      <div class="col-12 mt-3 text-normal p-0">
        GE Renewable Energy Supplier Support (<a href="mailto:GERenEnergy.SupplierSupport@ge.com" style="word-wrap: break-word;" class="text-highlight">~GE Vernova Supplier Support</a>)
      </div>      
    </div>
    <hr>
    <div class="d-flex col-12 no-gutters">
      <h6><strong class="mt-3 text-lable">Request Created</strong></h6>
      <div id="refresh" class="header-links ml-auto" style="padding-right: 2px;">
        <i class="fa fa-refresh" style="cursor: pointer; color: #005E60;"
        (click)="getListTicket($event)"></i>
      </div>
    </div>
    <div class="col-12 border-box no-gutters d-flex align-items-center justify-content-center">
      <div class="col-11 no-gutters">
        <div class="col-12 text-normal no-gutters" *ngFor="let item of request; let first = first; let last = last">
          <div class="pt-3 col-12" *ngIf="first">
            <div>
              Request submitted at
            </div>
            <div>
              {{item?.date | date:'medium'}}
            </div>
          </div>
          <div class="col-12" *ngIf="!first">
            <div>
              Request submitted at
            </div>
            <div>
              {{item?.date | date:'medium'}}
            </div>
          </div>
          <div class="py-2">
            <div>
              Request ID number:
            </div>
            <div>{{item?.number}}</div>
            <!-- <a style="text-decoration-line: underline; color: #007bff;cursor: pointer;" href="{{item?.requestUrl}}" target="_blank">
              {{item?.number}}
            </a> -->
          </div>
          <div class="pb-3" *ngIf="last && item?.status">
            <div>Status: </div>
            <div>{{item?.status}}</div>
          </div>
          <div *ngIf="!last && item?.status">
            <div>Status: </div>
            <div>{{item?.status}}</div>
          </div>
          <hr *ngIf="!last">
        </div>
      </div>
    </div>
  </div>
</div>